import {useParams} from 'react-router-dom'
import React, { useState } from 'react';

import {SpacesWithCustprofile} from '../containers'
function SpacesWithCustprofilePage() {
    let { id} = useParams();
    let svparams = { 'id': id}
    return (
        <div>
             {/* 
        <SpacesWithCustprofile svparams= {svparams} />
        */}
            <h3>My spaces hotelss </h3>
            <SpacesWithCustprofile svparams= {svparams} />
        </div>
       
        
        
       
    );
}
export default SpacesWithCustprofilePage